<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入敏感词搜索"
                   @on-enter="searchinput"/>
            <Button type="primary" @click="searchinput" class="search-btn">搜索</Button>
            <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="600" size="small" border
                 :columns="columns" :data="tableData"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false width="520">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem label="敏感词" prop="word">
                <Input v-model="formValidate.word" placeholder="请输入敏感词"></Input>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
                <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>
import {
  getSensitiveWordList,
  operationSensitiveWord,
} from '@/api/sys/security_sensitive_word.js'

export default {
  data() {
    return {
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '编辑'
      },
      editModalData: '',
      pageNum: 1,
      pageTotal: 0,
      pageSize: 15,

      ruleValidate: {
        word: [
          { required: true, message: '敏感词不能为空', trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: '序号',
          key: '_index',
          width: 65,
          align: 'center',
          render: (h, params) => {
            return h('span', params.index + 1 + (this.pageNum - 1) * this.pageSize);
          }
        },
        {
          title: '敏感词',
          key: 'word',
          align: 'center',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '创建时间',
          key: 'create_time',
          align: 'center',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: { type: 'primary', size: 'small' },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'put', '编辑');
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: { type: 'error', size: 'small' },
                  on: {
                    click: () => {
                      this.delData(params);
                    }
                  }
                },
                '删除'
              )
            ]);
          }
        }
      ],
    };
  },
  methods: {
    getSensitiveWordList(key) {
      this.spinShow = true;
      getSensitiveWordList(this.pageNum, this.pageSize, key).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count;
          this.tableData = res.data.data;
        } else {
          this.$Message.error(`${res.data.msg}`);
        }
        this.spinShow = false;
      });
    },
    delData(params) {
      if (confirm(`确定要删除该敏感词吗？`)) {
        operationSensitiveWord({ 'id': params.row.id }, 'delete').then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`);
            this.getSensitiveWordList(this.searchVal);
          } else {
            this.$Message.error(`${res.data.msg}`);
          }
        });
      }
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          word: paramsRow.word || ''
        };
      } else {
        this.formValidate = {
          id: 0,
          word: ''
        };
      }
    },
    handleSubmit(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          const submitData = {
            id: this.formValidate.id,
            word: this.formValidate.word.trim()
          };
          operationSensitiveWord(submitData, this.editModalData).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`);
              this.getSensitiveWordList(this.searchVal);
              this.modalMap.modalVisible = false;
            } else {
              this.$Message.error(`${res.data.msg}`);
            }
          });
        } else {
          this.$Message.error('缺少必要参数');
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    changePage(value) {
      this.pageNum = value;
      this.getSensitiveWordList(this.searchVal);
    },
    handlePageSize(value) {
      this.pageSize = value;
      this.pageNum = 1;
      this.getSensitiveWordList(this.searchVal);
    },
    searchinput() {
      this.pageNum = 1;
      this.getSensitiveWordList(this.searchVal);
    }
  },
  mounted() {
    this.getSensitiveWordList();
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col { display: inline-block; width: 200px; }
    &-input { display: inline-block; width: 200px; margin-left: 2px; }
    &-btn { margin-left: 2px; }
  }
}
</style>